<script setup lang="ts">
import type { ThemeContext } from '@shared/composables/useTheme';

defineProps<{
  themeClasses: ThemeContext['themeClasses']['value'];
}>();
</script>

<template>
  <div
    class="min-h-screen flex flex-col"
    :class="themeClasses.root"
  >
    <slot name="header" />
    <slot name="content" />
    <slot name="user-menu" />
  </div>
</template>
